import { AtlasMapValue, CachedImageData } from 'game-ui-types'

export interface AtlasImageStyles {
    backgroundImage: string
    backgroundPosition: string
    width: string
    height: string
    backgroundRepeat: string
    backgroundSize?: string
    transform?: string
    margin?: string
}

export const buildAtlasImageStyles = (
    atlasName: string,
    image: AtlasMapValue,
    cachedImage?: CachedImageData,
    scale = 1
): AtlasImageStyles | undefined => {
    if (!image) {
        return
    }

    let conditionalStyle = {}

    if (scale !== 1 && cachedImage) {
        conditionalStyle = { backgroundSize: `${cachedImage.width * scale}px ${cachedImage.height * scale}px` }
    }

    if (image.rotate) {
        // Rotated frames are stored 90deg clockwise, so the atlas region has its width/height swapped.
        // Rotate it back counter-clockwise and use margins to keep the layout box at width x height.
        const storedWidth = image.height * scale
        const storedHeight = image.width * scale
        const offset = (storedHeight - storedWidth) / 2

        return {
            backgroundImage: `url(${cachedImage?.url ?? atlasName})`,
            backgroundPosition: `-${image.x * scale}px -${image.y * scale}px`,
            width: `${storedWidth}px`,
            height: `${storedHeight}px`,
            backgroundRepeat: 'no-repeat',
            ...conditionalStyle,
            transform: 'rotate(-90deg)',
            margin: `${-offset}px ${offset}px`,
        }
    }

    return {
        backgroundImage: `url(${cachedImage?.url ?? atlasName})`,
        backgroundPosition: `-${image.x * scale}px -${image.y * scale}px`,
        width: `${image.width * scale}px`,
        height: `${image.height * scale}px`,
        backgroundRepeat: 'no-repeat',
        ...conditionalStyle,
    }
}
